import { IMG } from "@/lib/images";
import { Chapter } from "@/components/Reveal";
import PageHero from "@/components/PageHero";
import ContentRow from "@/components/ContentRow";
import SectionCTA from "@/components/SectionCTA";
import { usePageMeta } from "@/lib/site";

const ROWS = [
  {
    title: "Tenant Improvements & Build-Outs",
    copy: "Commercial spaces need to work on a schedule. We plan, coordinate, and build tenant improvements and build-outs with clear communication, honest timelines, and minimal disruption to your operation.",
    bullets: [
      "Office, retail, and flex-space improvements",
      "Scope development and preliminary budgeting",
      "Subcontractor and specialty trade coordination",
      "Quality control through completion",
    ],
    img: IMG.commercial,
  },
  {
    title: "Expansions & Property Improvements",
    copy: "Growing businesses eventually outgrow their space. We help evaluate, plan, and build expansions and property improvements that support where your business is going.",
    bullets: [
      "Building expansions and reconfigurations",
      "Property and facility improvements",
      "Engineering and permitting coordination",
      "Phased construction planning",
    ],
    img: IMG.blueprint,
  },
  {
    title: "Concrete & Site Solutions",
    copy: "Structural and flatwork concrete done right — the unglamorous work that everything else stands on, handled with proper preparation and proven process.",
    bullets: [
      "Flatwork, approaches, and pads",
      "Foundations and structural concrete",
      "Site preparation and exterior improvements",
      "Coordinated scheduling with other trades",
    ],
    img: IMG.concrete,
  },
  {
    title: "Project Management & Construction Solutions",
    copy: "Some projects need more than a crew — they need leadership. We provide full-scope construction management: evaluation, budgeting, coordination, permitting assistance, and accountability from start to finish.",
    bullets: [
      "Owner's-rep style project leadership",
      "Budget development and cost awareness",
      "Architect, engineer, and inspector coordination",
      "Single point of accountability",
    ],
    img: IMG.hero,
  },
];

export default function Commercial() {
  usePageMeta(
    "Commercial Construction & Improvements in Utah",
    "Black Sky Builders manages commercial tenant improvements, build-outs, expansions, and concrete work across Utah with clear communication and reliable coordination."
  );

  return (
    <div data-testid="commercial-page">
      <PageHero
        eyebrow="Commercial Construction"
        lines={["Built For", "Business"]}
        copy="Tenant improvements, build-outs, expansions, concrete, and complete construction management — with the coordination and accountability commercial projects demand."
        image={IMG.commercial}
      />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24 lg:px-16">
        <Chapter
          index="01"
          eyebrow="Commercial Services"
          title="Serious work, managed seriously"
          copy="Commercial construction lives and dies on coordination. Our team keeps architects, engineers, inspectors, and trades moving in the right order — and keeps you informed the whole way."
        />
        {ROWS.map((row, i) => (
          <ContentRow key={row.title} index={i} flip={i % 2 === 1} {...row} />
        ))}
      </section>
      <SectionCTA
        title="Let's talk about your commercial project"
        copy="Send us the scope — or just the idea — and our team will help determine the next steps."
      />
    </div>
  );
}
